import { ConfigPublicAPIsForDynamicConfigurationApi } from "../orchestrator-api-client";

export const getConfig = async () =>
  await new ConfigPublicAPIsForDynamicConfigurationApi().getConfiguration();
